import { render, staticRenderFns } from "./BarChartDialog.vue?vue&type=template&id=1d39ba60"
import script from "./BarChartDialog.vue?vue&type=script&lang=ts"
export * from "./BarChartDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports